__turbopack_context__.v({
  "checkbox": "styles-module-scss-module__9fdMia__checkbox",
  "checkbox_label": "styles-module-scss-module__9fdMia__checkbox_label",
  "contains_checkbox_with_icon": "styles-module-scss-module__9fdMia__contains_checkbox_with_icon",
  "has_icon": "styles-module-scss-module__9fdMia__has_icon",
  "header": "styles-module-scss-module__9fdMia__header",
  "is_checked": "styles-module-scss-module__9fdMia__is_checked",
  "layout_flex_row": "styles-module-scss-module__9fdMia__layout_flex_row",
  "layout_is_half": "styles-module-scss-module__9fdMia__layout_is_half",
  "layout_is_third": "styles-module-scss-module__9fdMia__layout_is_third",
});
